import { c as _c } from "react/compiler-runtime";
import { Dispatch, SetStateAction, useState } from 'react';
import { useEventCallback } from '../useEventCallback';

/**
 * a hook to control an opened state
 */
export function useOpened() {
  const $ = _c(6);
  const [opened, setOpened] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setOpened(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const close = useEventCallback(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setOpened(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const open = useEventCallback(t1);
  let t2;
  if ($[2] !== close || $[3] !== open || $[4] !== opened) {
    t2 = {
      opened,
      setOpened,
      close,
      open
    };
    $[2] = close;
    $[3] = open;
    $[4] = opened;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export type UseOpenedReturnValue = {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  close: () => void;
  open: () => void;
};